import { cn } from "@/lib/utils";

// A large, prominent result display used by every calculator.
export function ResultCard({ label, value, unit, children, tone = "default", testId = "result" }) {
  const toneClasses = {
    default: "bg-primary text-primary-foreground",
    good: "bg-emerald-600 text-white dark:bg-emerald-500",
    warning: "bg-amber-500 text-black",
    danger: "bg-red-600 text-white",
  };
  return (
    <div
      data-testid={testId}
      className={cn(
        "rounded-2xl p-6 sm:p-8 flex flex-col items-start gap-2",
        toneClasses[tone] || toneClasses.default
      )}
    >
      <span className="text-xs uppercase tracking-wider opacity-80">{label}</span>
      <div className="flex items-baseline gap-2 flex-wrap">
        <span className="text-4xl sm:text-5xl font-bold tracking-tight">{value}</span>
        {unit && <span className="text-lg opacity-80">{unit}</span>}
      </div>
      {children && <div className="text-sm opacity-90 mt-1">{children}</div>}
    </div>
  );
}

// A BMI-style horizontal band gauge with a marker for the current value.
export function BandGauge({ value, min, max, bands, testId = "gauge" }) {
  const total = max - min;
  const pct = Math.max(0, Math.min(100, ((value - min) / total) * 100));
  return (
    <div className="mt-4" data-testid={testId}>
      <div className="relative h-3 w-full rounded-full overflow-hidden flex">
        {bands.map((b, i) => {
          const width = ((b.to - b.from) / total) * 100;
          return (
            <div
              key={i}
              className={cn("h-full", b.color)}
              style={{ width: `${width}%` }}
              title={b.label}
            />
          );
        })}
        <div
          className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 h-5 w-5 rounded-full bg-background border-2 border-foreground shadow"
          style={{ left: `${pct}%` }}
          aria-label={`Current value ${value}`}
        />
      </div>
      <div className="mt-2 flex justify-between text-[10px] text-muted-foreground">
        {bands.map((b, i) => <span key={i}>{b.label}</span>)}
      </div>
    </div>
  );
}
